import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { HomeData } from '../../api/types';
import logo from '../../images/CERN_logo.svg';
import { roundImageStyle } from '../../utils/utils';
import { RoundImage } from '../RoundImage/RoundImage';
import { SituationIndicator } from '../SituationIndicator/SituationIndicator';
import { useTranslations } from '../Translations/TranslationsProvider';
import { UserDetails } from '../UserDetails/UserDetails';

const styles = {
    root: roundImageStyle,
    circle: {
        ...roundImageStyle,
        border: '2px solid black',
    },
    visitorCircle: {
        ...roundImageStyle,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid black',
    },
};
interface UserSiteAccessInfoProps {
    data: HomeData;
    isVisitor?: boolean;
    userPicture?: string;
    visitorLabel?: string;
}

export const UserSiteAccessInfo: React.FC<UserSiteAccessInfoProps> = ({
    data,
    isVisitor = false,
    userPicture = undefined,
    visitorLabel = '',
}) => {
    const { firstName, lastName, siteAccessSituation, siteDescription } = data;
    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return (
        <>
            <Box mb={4} textAlign="center">
                {isVisitor ? (
                    <Box textAlign="center">
                        <div style={styles.visitorCircle}>
                            <Typography variant="h5">{visitorLabel.toUpperCase()}</Typography>
                        </div>
                        <Typography id="username" variant="h5">
                            {firstName}
                            <br />
                            {lastName.toUpperCase()}
                        </Typography>
                    </Box>
                ) : (
                    <UserDetails firstName={firstName} lastName={lastName} userPicture={userPicture} />
                )}
            </Box>

            <Box textAlign="center">
                <RoundImage style={styles.circle} src={logo} alt="CERN" />

                <Typography variant="h5">CERN</Typography>
                <Typography color="textSecondary">{siteDescription}</Typography>
            </Box>

            <Box textAlign="center" mt={2}>
                <SituationIndicator
                    negativeStatusText={translations.ACCESS_POINT_STOP}
                    positiveStatusText={translations.ACCESS_POINT_GO}
                    situation={siteAccessSituation}
                    style={styles.root}
                />
            </Box>
        </>
    );
};
